export default __webpack_public_path__ + "static/media/secret_2.d49ad92d.jpg";